// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league_match_team_assistance_section-team-information,
.league_match_team_assistance_section-player-photo{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--space-half);
}

.league_match_team_assistance_section-team{
    width: 50%;
    background: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
}

.league_match_team_assistance_section-team.fullScreen{
    width: 100%;
}

.league__match_assistance_section-player-team{
    overflow-y: scroll;
    height: 320px;
}

.league_match_team_assistance_section-team_photo{
    width: 40px;
    border-radius: 50%;
}

.league_match_team_assistance_section-team_names .baloa-table{
    color: var(--primary-very-dark-color);
}

.league_match_team_assistance_section-team_names .baloa-mini{
    color: var(--primary-dark-color);
}

.league_match_team_assistance_section-team-information .icon-ball{
    color: var(--white-color );
    font-size: 35px;
    border-radius: 50%;
    padding: 3px;
}

.league_match_team_assistance_section-player-photo .icon-ball{
    color: var(--white-color );
    font-size: 40px;
    border-radius: 50%;
    padding: 3px;
}

.league_match_team_assistance_section-player_names{
    display: flex;
    flex-direction: column;
}

.league_match_team_assistance_section-player_names .baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.league_match_team_assistance_section-player_names .baloa-mini{
    color: var(--primary-dark-color);
}

.league_match_team_assistance_section-title-optionsInf{
    margin: var(--space) 0 ;
    background: var(--new-background-color);
    border-radius: 4px;
    padding: var(--space-half);
}

.league_match_team_assistance_section-title-optionsInf .baloa-mini{
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.league_match_team_assistance_section-title-optionsInf,
.league_match_team_assistance_section-title-option-rigth{
    display: flex;
    justify-content: space-between;
    gap:var(--space);
}

.league_match_team_assistance_checkbox-form{
    display: flex;
    align-items: flex-end;
    margin: var(--space-half) 0;
}

.league_match_team_assistance_checkbox-form_input{
    width: var(--space);
    height: var(--space);
    margin-right: 9px;
}

.league_match_team_assistance_checkbox-form_label .baloa-username{
    color: var(--primary-dark-color);
}

input[type="checkbox"]:before {
	content: "";
	width: 18px;
	height: 18px;
	float: left;
	/* margin: 0.5em 0.5em 0 0; */
	border: 1px solid #00000099;
    border-radius: 2px;
	background:var(--white-color);
}

input[type="checkbox"]:checked:before {
	border-color: var(--white-color);
    background: var(--new-green-color);
    border: 1px solid #ccc;
}

input[type="checkbox"]:checked:after {
    content: "";
    width: 11px;
    height: 6px;
    border: 2px solid var(--white-color);
    float: left;
    margin-left: 3px;
    border-right: 0;
    border-top: 0;
    margin-top: -13px;
    transform: rotate(-55deg);
}

.league_match_team_assistance_section-player-information{
    margin: var(--space) 0;
    border-right: 1.5px solid var(--new-gray-background-color);
    width: 60%;
    padding-right: 10px;
}

.league_match_team_assistance_section-player{
    display: flex;
    align-items: center;
    flex-direction: row;
    border-top: 1px solid #ccc;
    gap: 20px
}

.league_match_team_assistance_section--photo.disabled,
.league_match_team_assistance_section-player_names.disabled,
.league_match_team_assistance_section-player-rol.disabled,
.league_match_team_assistance_section-player-actions.disabled{
    opacity: 0.4;
}

.league_match_team_assistance_section-player-rol{
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-start;
    gap: var(--space);
    width: 100%;
}

.league_match_team_assistance_section-player-rol .input-field.league_match_team_assistance_form-player-number{
    margin: 8px 0;
    width: 50%;
}

.league_match_team_assistance_section-player-rol .input-field.league_match_team_assistance_form-player-number .input-field-input{
    background: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    height: 39px;
}

.league_match_team_assistance_section-player-rol .select-field {
    margin: var(--space-half) 0px;
    width: 50%;
}

.league_match_team_assistance_section-player-rol .select-field .MuiInputBase-root.select-field-input{
    background:var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    height: 40px;
}

.league_match_team_assistance_section-player-actions{
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 40%;
}

.league_match_team_assistance_content__option-button .MuiFormControlLabel-root{
    border: solid 1px var(--new-gray-background-color);
    border-radius: 9px;
    padding: 3px 5px;
    height: 40px;
    margin: 0px;
}

.league_match_team_assistance_content__option-button.inside {
    color: var(--primary-dark-color);
    gap: 8px;
}

.league_match_team_assistance_content__option-button .MuiFormControlLabel-root.selected{
    border: solid 1px var(--basic-green-color);
}

.league_match_assistance-footer{
    display: grid;
    justify-content: end;
    margin: var(--space-and-half);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-team-assistance/LeagueMatchTeamAssistance.styles.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,oDAAoD;IACpD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;IACvC,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,WAAW;CACX,6BAA6B;CAC7B,2BAA2B;IACxB,kBAAkB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,gCAAgC;IAC7B,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,0DAA0D;IAC1D,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B;AACJ;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,oDAAoD;IACpD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,oDAAoD;IACpD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,QAAQ;AACZ;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,6BAA6B;AACjC","sourcesContent":[".league_match_team_assistance_section-team-information,\n.league_match_team_assistance_section-player-photo{\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: var(--space-half);\n}\n\n.league_match_team_assistance_section-team{\n    width: 50%;\n    background: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n}\n\n.league_match_team_assistance_section-team.fullScreen{\n    width: 100%;\n}\n\n.league__match_assistance_section-player-team{\n    overflow-y: scroll;\n    height: 320px;\n}\n\n.league_match_team_assistance_section-team_photo{\n    width: 40px;\n    border-radius: 50%;\n}\n\n.league_match_team_assistance_section-team_names .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.league_match_team_assistance_section-team_names .baloa-mini{\n    color: var(--primary-dark-color);\n}\n\n.league_match_team_assistance_section-team-information .icon-ball{\n    color: var(--white-color );\n    font-size: 35px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league_match_team_assistance_section-player-photo .icon-ball{\n    color: var(--white-color );\n    font-size: 40px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league_match_team_assistance_section-player_names{\n    display: flex;\n    flex-direction: column;\n}\n\n.league_match_team_assistance_section-player_names .baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.league_match_team_assistance_section-player_names .baloa-mini{\n    color: var(--primary-dark-color);\n}\n\n.league_match_team_assistance_section-title-optionsInf{\n    margin: var(--space) 0 ;\n    background: var(--new-background-color);\n    border-radius: 4px;\n    padding: var(--space-half);\n}\n\n.league_match_team_assistance_section-title-optionsInf .baloa-mini{\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.league_match_team_assistance_section-title-optionsInf,\n.league_match_team_assistance_section-title-option-rigth{\n    display: flex;\n    justify-content: space-between;\n    gap:var(--space);\n}\n\n.league_match_team_assistance_checkbox-form{\n    display: flex;\n    align-items: flex-end;\n    margin: var(--space-half) 0;\n}\n\n.league_match_team_assistance_checkbox-form_input{\n    width: var(--space);\n    height: var(--space);\n    margin-right: 9px;\n}\n\n.league_match_team_assistance_checkbox-form_label .baloa-username{\n    color: var(--primary-dark-color);\n}\n\ninput[type=\"checkbox\"]:before {\n\tcontent: \"\";\n\twidth: 18px;\n\theight: 18px;\n\tfloat: left;\n\t/* margin: 0.5em 0.5em 0 0; */\n\tborder: 1px solid #00000099;\n    border-radius: 2px;\n\tbackground:var(--white-color);\n}\n\ninput[type=\"checkbox\"]:checked:before {\n\tborder-color: var(--white-color);\n    background: var(--new-green-color);\n    border: 1px solid #ccc;\n}\n\ninput[type=\"checkbox\"]:checked:after {\n    content: \"\";\n    width: 11px;\n    height: 6px;\n    border: 2px solid var(--white-color);\n    float: left;\n    margin-left: 3px;\n    border-right: 0;\n    border-top: 0;\n    margin-top: -13px;\n    transform: rotate(-55deg);\n}\n\n.league_match_team_assistance_section-player-information{\n    margin: var(--space) 0;\n    border-right: 1.5px solid var(--new-gray-background-color);\n    width: 60%;\n    padding-right: 10px;\n}\n\n.league_match_team_assistance_section-player{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    border-top: 1px solid #ccc;\n    gap: 20px\n}\n\n.league_match_team_assistance_section--photo.disabled,\n.league_match_team_assistance_section-player_names.disabled,\n.league_match_team_assistance_section-player-rol.disabled,\n.league_match_team_assistance_section-player-actions.disabled{\n    opacity: 0.4;\n}\n\n.league_match_team_assistance_section-player-rol{\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: flex-start;\n    gap: var(--space);\n    width: 100%;\n}\n\n.league_match_team_assistance_section-player-rol .input-field.league_match_team_assistance_form-player-number{\n    margin: 8px 0;\n    width: 50%;\n}\n\n.league_match_team_assistance_section-player-rol .input-field.league_match_team_assistance_form-player-number .input-field-input{\n    background: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    height: 39px;\n}\n\n.league_match_team_assistance_section-player-rol .select-field {\n    margin: var(--space-half) 0px;\n    width: 50%;\n}\n\n.league_match_team_assistance_section-player-rol .select-field .MuiInputBase-root.select-field-input{\n    background:var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    height: 40px;\n}\n\n.league_match_team_assistance_section-player-actions{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    width: 40%;\n}\n\n.league_match_team_assistance_content__option-button .MuiFormControlLabel-root{\n    border: solid 1px var(--new-gray-background-color);\n    border-radius: 9px;\n    padding: 3px 5px;\n    height: 40px;\n    margin: 0px;\n}\n\n.league_match_team_assistance_content__option-button.inside {\n    color: var(--primary-dark-color);\n    gap: 8px;\n}\n\n.league_match_team_assistance_content__option-button .MuiFormControlLabel-root.selected{\n    border: solid 1px var(--basic-green-color);\n}\n\n.league_match_assistance-footer{\n    display: grid;\n    justify-content: end;\n    margin: var(--space-and-half);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
